import Vue from "vue";
import Vuex from "vuex";
import main from "./main";
import sideMenu from "./side-menu";
import filtersMenu from "./filters";
import simpleMenu from "./simple-menu";
import topMenu from "./top-menu";
import icons from "./icons";
import notes from "./acja-notes";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    main: main,
    sideMenu: sideMenu,
    filtersMenu: filtersMenu,
    simpleMenu: simpleMenu,
    topMenu: topMenu,
    icons: icons,
    notes: notes
  }
});
